var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',{attrs:{"d":"flex","flexDir":"column","justifyContent":"center"}},[_c('Editable',{attrs:{"defaultValue":"Take some chakra"}},[_c('EditablePreview'),_c('EditableInput')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }